module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-004.a2524b71.jpg";